// extracted by mini-css-extract-plugin
module.exports = {"rootPortal":"Main_rootPortal__28mLs"};